import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { Survey } from 'app/entities/nps-survey';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NpsService {
    // Fila de pesquisas elegíveis
    private surveyQueue: Survey[] = [];
    
    // Subject para controlar o estado da fila de pesquisas
    private surveyQueueSubject = new BehaviorSubject<Survey[]>([]);
    
    // Observable público para componentes se inscreverem nas mudanças da fila
    public surveyQueue$ = this.surveyQueueSubject.asObservable();
    
    // Flag para indicar se já carregamos as pesquisas
    private surveysLoaded = false;

    constructor(private httpService: HttpService) { }

    /**
     * Método legado para compatibilidade com versões anteriores
     * Retorna apenas a primeira pesquisa elegível
     */
    getElegibleSurvey(): Observable<Survey> {
        return this.httpService.get('/v1/clients/nps/elegible-survey').pipe(
            map(res => Survey.parse(res?.data) as Survey)
        );
    }
    
    /**
     * Obtém todas as pesquisas elegíveis e atualiza a fila
     */
    getElegibleSurveys(): Observable<Survey[]> {
        return this.httpService.get('/v1/clients/nps/elegible-surveys').pipe(
            map(res => {
                const surveys = Array.isArray(res?.data) 
                    ? res.data.map(survey => Survey.parse(survey) as Survey)
                    : [];
                    
                // Atualiza a fila interna
                this.updateSurveyQueue(surveys);
                
                return surveys;
            })
        );
    }
    
    /**
     * Atualiza a fila de pesquisas
     */
    private updateSurveyQueue(surveys: Survey[]): void {
        this.surveyQueue = surveys;
        this.surveyQueueSubject.next(this.surveyQueue);
        this.surveysLoaded = true;
    }
    
    /**
     * Obtém a próxima pesquisa da fila
     */
    getNextSurvey(): Survey | null {
        return this.surveyQueue.length > 0 ? this.surveyQueue[0] : null;
    }
    
    /**
     * Remove uma pesquisa da fila após ser respondida
     */
    removeSurveyFromQueue(surveyId: number): void {
        this.surveyQueue = this.surveyQueue.filter(survey => survey.id !== surveyId);
        this.surveyQueueSubject.next(this.surveyQueue);
    }
    
    /**
     * Verifica se existem pesquisas na fila
     */
    hasSurveysInQueue(): boolean {
        return this.surveyQueue.length > 0;
    }
    
    /**
     * Carrega as pesquisas elegíveis se ainda não foram carregadas
     */
    loadSurveysIfNeeded(): Observable<Survey[]> {
        if (!this.surveysLoaded) {
            return this.getElegibleSurveys();
        }
        
        // Retorna a fila atual como um Observable
        return new Observable<Survey[]>(observer => {
            observer.next(this.surveyQueue);
            observer.complete();
        });
    }

    submitSurvey(surveyID, surveyData): Observable<any> {
        return this.httpService.post('/v1/clients/nps/'+surveyID, surveyData);
    }
}
